import {
  CalendarDateDimension,
  FinancialRateDimension,
  FinancialRateWithUnsetDimension,
  StringsEnumDimension,
  TextDimension,
} from '@orus.eu/dimensions'
import { frRcpwProductVersions, frRcpwSegments } from '@orus.eu/product'

export const frRcpwProductVersionDimension = new StringsEnumDimension({
  name: 'frRcpwProductVersion',
  displayKeys: { name: 'dimension_name_fr_rcpw_product_version' },
  values: frRcpwProductVersions,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpwSegmentDimension = new StringsEnumDimension({
  name: 'frRcpwSegment',
  displayKeys: { name: 'dimension_name_fr_rcpw_segment' },
  values: frRcpwSegments,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

//#region Fees
export const frRcpwDefaultManagementFeeRateDimension = new FinancialRateDimension({
  name: 'frRcpwDefaultManagementFeeRate',
  displayKeys: { name: 'dimension_name_fr_rcpw_default_management_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const frRcpwManuallySetManagementFeeRateDimension = new FinancialRateWithUnsetDimension({
  name: 'frRcpwManuallySetManagementFeeRate',
  displayKeys: { name: 'dimension_name_fr_rcpw_manually_set_management_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const frRcpwManagementFeeRateDimension = new FinancialRateDimension({
  name: 'frRcpwManagementFeeRate',
  displayKeys: { name: 'dimension_name_fr_rcpw_management_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpwDefaultInstallmentFeeRateDimension = new FinancialRateDimension({
  name: 'frRcpwDefaultInstallmentFeeRate',
  displayKeys: { name: 'dimension_name_fr_rcpw_default_installment_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const frRcpwManuallySetInstallmentFeeRateDimension = new FinancialRateWithUnsetDimension({
  name: 'frRcpwManuallySetInstallmentFeeRate',
  displayKeys: { name: 'dimension_name_fr_rcpw_manually_set_installment_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const frRcpwInstallmentFeeRateDimension = new FinancialRateDimension({
  name: 'frRcpwInstallmentFeeRate',
  displayKeys: { name: 'dimension_name_fr_rcpw_installment_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
//#endregion Fees

//#region Overcharges
const frRcpwOverchargeConfiguration = { min: 0, max: 10, step: 0.01 }

export const frRcpwCivilLiabilityOverchargeRateDimension = new FinancialRateDimension({
  name: 'frRcpwCivilLiabilityOverchargeRate',
  displayKeys: { name: 'dimension_name_fr_rcpw_civil_liability_overcharge_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: true,
  inputLocking: undefined,
  configuration: frRcpwOverchargeConfiguration,
})
export const frRcpwLegalProtectionOverchargeRateDimension = new FinancialRateDimension({
  name: 'frRcpwLegalProtectionOverchargeRate',
  displayKeys: { name: 'dimension_name_fr_rcpw_legal_protection_overcharge_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: true,
  inputLocking: undefined,
  configuration: frRcpwOverchargeConfiguration,
})
//#endregion Overcharges

export const frRcpwMinBirthDateDimension = new CalendarDateDimension({
  name: 'frRcpwMinBirthDate',
  displayKeys: { name: 'dimension_name_fr_rcpw_min_birth_date' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpwMaxBirthDateDimension = new CalendarDateDimension({
  name: 'frRcpwMaxBirthDate',
  displayKeys: { name: 'dimension_name_fr_rcpw_max_birth_date' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: false },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpwCustomActivityDimension = new TextDimension({
  name: 'frRcpwCustomActivity',
  displayKeys: { name: 'dimension_name_fr_rcpw_custom_activity', hint: 'dimension_hint_fr_rcpw_custom_activity' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const frRcpwCustomSummaryDimension = new TextDimension({
  name: 'frRcpwCustomSummary',
  displayKeys: { name: 'dimension_name_fr_rcpw_custom_summary', hint: 'dimension_hint_fr_rcpw_custom_summary' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
